export default __webpack_public_path__ + "static/media/connected-integrations.09d3d101.svg";